/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    Carriers,
    CarriersFromJSON,
    CarriersFromJSONTyped,
    CarriersToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    FareBasisCode,
    FareBasisCodeFromJSON,
    FareBasisCodeFromJSONTyped,
    FareBasisCodeToJSON,
    FormDataRouteRestriction,
    FormDataRouteRestrictionFromJSON,
    FormDataRouteRestrictionFromJSONTyped,
    FormDataRouteRestrictionToJSON,
    RuleFormDataAgencyOrGroup,
    RuleFormDataAgencyOrGroupFromJSON,
    RuleFormDataAgencyOrGroupFromJSONTyped,
    RuleFormDataAgencyOrGroupToJSON,
} from './';

/**
 * 
 * @export
 * @interface GlobalFilterRuleFormData
 */
export interface GlobalFilterRuleFormData {
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterRuleFormData
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterRuleFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterRuleFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterRuleFormData
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterRuleFormData
     */
    comment?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof GlobalFilterRuleFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {number}
     * @memberof GlobalFilterRuleFormData
     */
    relevance?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof GlobalFilterRuleFormData
     */
    distributionChannels?: Array<number> | null;
    /**
     * 
     * @type {Array<RuleFormDataAgencyOrGroup>}
     * @memberof GlobalFilterRuleFormData
     */
    agenciesAndGroups?: Array<RuleFormDataAgencyOrGroup> | null;
    /**
     * 
     * @type {Array<FormDataRouteRestriction>}
     * @memberof GlobalFilterRuleFormData
     */
    routes?: Array<FormDataRouteRestriction> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GlobalFilterRuleFormData
     */
    salesJourneys?: Array<string> | null;
    /**
     * 
     * @type {object}
     * @memberof GlobalFilterRuleFormData
     */
    maxConnectionTimeFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof GlobalFilterRuleFormData
     */
    maxConnectionTimeTo?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterRuleFormData
     */
    allow?: boolean;
    /**
     * 
     * @type {object}
     * @memberof GlobalFilterRuleFormData
     */
    effectiveFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof GlobalFilterRuleFormData
     */
    effectiveTo?: object | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GlobalFilterRuleFormData
     */
    marketingFlightNumbers?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GlobalFilterRuleFormData
     */
    providers?: Array<string> | null;
    /**
     * 
     * @type {Array<FareBasisCode>}
     * @memberof GlobalFilterRuleFormData
     */
    fareBases?: Array<FareBasisCode> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof GlobalFilterRuleFormData
     */
    fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<Carriers>}
     * @memberof GlobalFilterRuleFormData
     */
    carriers?: Array<Carriers> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GlobalFilterRuleFormData
     */
    bookingClasses?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterRuleFormData
     */
    marketingFlightNumbersMatch?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterRuleFormData
     */
    fareBasesMatch?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterRuleFormData
     */
    carriersMatch?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterRuleFormData
     */
    bookingClassesMatch?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterRuleFormData
     */
    baglessFaresMatch?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterRuleFormData
     */
    doubleConnectionsMatch?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterRuleFormData
     */
    multiAirportConnectionsMatch?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GlobalFilterRuleFormData
     */
    accountCodes?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GlobalFilterRuleFormData
     */
    mixAndMatchProviders?: Array<string> | null;
}

export function GlobalFilterRuleFormDataFromJSON(json: any): GlobalFilterRuleFormData {
    return GlobalFilterRuleFormDataFromJSONTyped(json, false);
}

export function GlobalFilterRuleFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterRuleFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : json['distributionChannels'],
        'agenciesAndGroups': !exists(json, 'agenciesAndGroups') ? undefined : (json['agenciesAndGroups'] === null ? null : (json['agenciesAndGroups'] as Array<any>).map(RuleFormDataAgencyOrGroupFromJSON)),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(FormDataRouteRestrictionFromJSON)),
        'salesJourneys': !exists(json, 'salesJourneys') ? undefined : json['salesJourneys'],
        'maxConnectionTimeFrom': !exists(json, 'maxConnectionTimeFrom') ? undefined : json['maxConnectionTimeFrom'],
        'maxConnectionTimeTo': !exists(json, 'maxConnectionTimeTo') ? undefined : json['maxConnectionTimeTo'],
        'allow': !exists(json, 'allow') ? undefined : json['allow'],
        'effectiveFrom': !exists(json, 'effectiveFrom') ? undefined : json['effectiveFrom'],
        'effectiveTo': !exists(json, 'effectiveTo') ? undefined : json['effectiveTo'],
        'marketingFlightNumbers': !exists(json, 'marketingFlightNumbers') ? undefined : json['marketingFlightNumbers'],
        'providers': !exists(json, 'providers') ? undefined : json['providers'],
        'fareBases': !exists(json, 'fareBases') ? undefined : (json['fareBases'] === null ? null : (json['fareBases'] as Array<any>).map(FareBasisCodeFromJSON)),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'carriers': !exists(json, 'carriers') ? undefined : (json['carriers'] === null ? null : (json['carriers'] as Array<any>).map(CarriersFromJSON)),
        'bookingClasses': !exists(json, 'bookingClasses') ? undefined : json['bookingClasses'],
        'marketingFlightNumbersMatch': !exists(json, 'marketingFlightNumbersMatch') ? undefined : json['marketingFlightNumbersMatch'],
        'fareBasesMatch': !exists(json, 'fareBasesMatch') ? undefined : json['fareBasesMatch'],
        'carriersMatch': !exists(json, 'carriersMatch') ? undefined : json['carriersMatch'],
        'bookingClassesMatch': !exists(json, 'bookingClassesMatch') ? undefined : json['bookingClassesMatch'],
        'baglessFaresMatch': !exists(json, 'baglessFaresMatch') ? undefined : json['baglessFaresMatch'],
        'doubleConnectionsMatch': !exists(json, 'doubleConnectionsMatch') ? undefined : json['doubleConnectionsMatch'],
        'multiAirportConnectionsMatch': !exists(json, 'multiAirportConnectionsMatch') ? undefined : json['multiAirportConnectionsMatch'],
        'accountCodes': !exists(json, 'accountCodes') ? undefined : json['accountCodes'],
        'mixAndMatchProviders': !exists(json, 'mixAndMatchProviders') ? undefined : json['mixAndMatchProviders'],
    };
}

export function GlobalFilterRuleFormDataToJSON(value?: GlobalFilterRuleFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'allowEdit': value.allowEdit,
        'disabled': value.disabled,
        'description': value.description,
        'comment': value.comment,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'relevance': value.relevance,
        'distributionChannels': value.distributionChannels,
        'agenciesAndGroups': value.agenciesAndGroups === undefined ? undefined : (value.agenciesAndGroups === null ? null : (value.agenciesAndGroups as Array<any>).map(RuleFormDataAgencyOrGroupToJSON)),
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(FormDataRouteRestrictionToJSON)),
        'salesJourneys': value.salesJourneys,
        'maxConnectionTimeFrom': value.maxConnectionTimeFrom,
        'maxConnectionTimeTo': value.maxConnectionTimeTo,
        'allow': value.allow,
        'effectiveFrom': value.effectiveFrom,
        'effectiveTo': value.effectiveTo,
        'marketingFlightNumbers': value.marketingFlightNumbers,
        'providers': value.providers,
        'fareBases': value.fareBases === undefined ? undefined : (value.fareBases === null ? null : (value.fareBases as Array<any>).map(FareBasisCodeToJSON)),
        'fareTypes': value.fareTypes === undefined ? undefined : (value.fareTypes === null ? null : (value.fareTypes as Array<any>).map(CodeAndLabelToJSON)),
        'carriers': value.carriers === undefined ? undefined : (value.carriers === null ? null : (value.carriers as Array<any>).map(CarriersToJSON)),
        'bookingClasses': value.bookingClasses,
        'marketingFlightNumbersMatch': value.marketingFlightNumbersMatch,
        'fareBasesMatch': value.fareBasesMatch,
        'carriersMatch': value.carriersMatch,
        'bookingClassesMatch': value.bookingClassesMatch,
        'baglessFaresMatch': value.baglessFaresMatch,
        'doubleConnectionsMatch': value.doubleConnectionsMatch,
        'multiAirportConnectionsMatch': value.multiAirportConnectionsMatch,
        'accountCodes': value.accountCodes,
        'mixAndMatchProviders': value.mixAndMatchProviders,
    };
}


